import type { WalkthroughConfig } from "../types";

export const eventsWalkthrough: WalkthroughConfig = {
  id: "page-events",
  title: "Events Management",
  description: "Learn how to create, manage, and track events for your organization.",
  type: "page",
  pageRoute: "/events",
  duration: "1 min",
  category: "pages",
  icon: "CalendarDays",
  steps: [
    {
      id: "intro",
      title: "Events Hub",
      description: "Create and manage all your organization's events — from small meetups to large conferences. Track registrations, revenue, and attendance in one place.",
      placement: "center",
      animation: "fade",
      icon: "CalendarDays",
    },
    {
      id: "types",
      title: "Event Types & Formats",
      description: "Support in-person, virtual, and hybrid events. Categorize by type (networking, education, social, fundraising) to track your programming mix.",
      placement: "center",
      animation: "slide-up",
      icon: "Layers",
    },
    {
      id: "registration",
      title: "Registration & Tickets",
      description: "Set up member vs non-member pricing, early bird rates, capacity limits, and waitlists. Members can register directly from their portal.",
      placement: "center",
      animation: "fade",
      icon: "Ticket",
    },
    {
      id: "tracking",
      title: "Check-in & Analytics",
      description: "Use QR codes for check-in, track attendance rates, and analyze event ROI. Post-event data feeds into member engagement scores.",
      placement: "center",
      animation: "scale",
      icon: "BarChart3",
      nextLabel: "Got it! ✓",
    },
  ],
};
